import React from 'react'
import '../../styles/global.scss'
import { KabinetViewProps } from './Kabinet'
import { AuthProvider, NotificationProvider, ProfileProvider } from '../../contexts'

export const KabinetView = (props: KabinetViewProps): JSX.Element => {
  const {
    rootUrl,
    wsUrl,
    children
  }: KabinetViewProps = props

  return (
    <AuthProvider rootUrl={rootUrl}>
      <ProfileProvider rootUrl={rootUrl}>
        <NotificationProvider>
          {children}
        </NotificationProvider>
      </ProfileProvider>
    </AuthProvider>
  )
}
